import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail1: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="email-1, envelope"><path d="M21.25 19.25V4.75H2.75V19.25H21.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3 5.63635L12 13L21 5.63635" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconEmail1;
